import { ComponentProps, ReactNode } from 'react';
import ItemMenu from '../ItemMenu';
import { useTranslation } from '../../lib/i18n/TranslationContext';
import { twMerge } from 'tailwind-merge';

type IntegracaoBtnProps = ComponentProps<typeof ItemMenu> & {
	children: ReactNode;
	isActive?: boolean;
};

const IntegracaoBtn = ({ children, isActive, ...props }: IntegracaoBtnProps) => {
	const { t } = useTranslation();
	return <ItemMenu asChild {...props} className={twMerge(props?.className, '[&_svg]:stroke-[2.3] [&_svg]:size-5')} isActive={isActive} tooltip={t('Integração')}>{children}</ItemMenu>;
};

export default IntegracaoBtn;
